import { V1_REQUEST_TOUR_OPERATORS } from '../../actions/tourOperators/v1requestTourOperators'
import { V1_RECEIVE_TOUR_OPERATORS } from '../../actions/tourOperators/v1receiveTourOperators'
import { V1_RECEIVE_FILTERED_TOUR_OPERATORS } from '../../actions/tourOperators/v1receiveFilteredTourOperators'

export const initialState = {
  isFetching: false,
  items: [],
  isRequestCompleted: false,
  filteredTourOperators: [],
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case V1_REQUEST_TOUR_OPERATORS:
      return {
        ...state,
        isFetching: true,
        isRequestCompleted: false,
      }
    case V1_RECEIVE_TOUR_OPERATORS:
      return {
        ...state,
        isFetching: false,
        items: action.data,
        isRequestCompleted: true,
      }
    case V1_RECEIVE_FILTERED_TOUR_OPERATORS:
      return {
        ...state,
        filteredTourOperators: action.data,
      }
    default:
      return state
  }
}
